import { render, staticRenderFns } from "./SuccessShow.vue?vue&type=template&id=52dc989d&scoped=true"
import script from "./SuccessShow.vue?vue&type=script&lang=js"
export * from "./SuccessShow.vue?vue&type=script&lang=js"
import style0 from "./SuccessShow.vue?vue&type=style&index=0&id=52dc989d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc989d",
  null
  
)

export default component.exports